import type { AgentConversation } from '@/redux/internal-services/agentApi';
import { PlusIcon, TrashIcon } from '@/components/chat/ChatIcons';

function relTime(iso?: string): string {
  if (!iso) return '';
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'now';
  const m = Math.floor(s / 60); if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60); if (h < 24) return `${h}h`;
  return `${Math.floor(h / 24)}d`;
}

export const SessionsDrawer = ({
  open, onClose, sessions, activeId, onSelect, onNew, onDelete,
}: {
  open: boolean;
  onClose: () => void;
  sessions: AgentConversation[];
  activeId: string;
  onSelect: (id: string) => void;
  onNew: () => void;
  onDelete: (id: string) => void;
}) => {
  if (!open) return null;
  return (
    <div className="absolute inset-0 z-30 flex">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden />
      <div className="relative z-10 flex h-full w-72 max-w-[80%] flex-col border-r border-ui-border bg-ui-card">
        <div className="flex items-center justify-between border-b border-ui-border px-3 py-3">
          <span className="text-sm font-semibold text-ui-text">Chats</span>
          <button onClick={onClose} className="text-ui-text2 hover:text-ui-text">✕</button>
        </div>
        <div className="p-3">
          <button onClick={onNew} className="flex w-full items-center justify-center gap-1.5 rounded-lg btn-sheen py-2 text-sm font-medium text-on-primary transition">
            <PlusIcon className="h-4 w-4" /> New chat
          </button>
        </div>
        <div className="no-scrollbar flex-1 space-y-1 overflow-y-auto px-2 pb-3">
          {sessions.length === 0 && <p className="px-2 py-4 text-center text-xs text-ui-text3">No chats yet.</p>}
          {sessions.map((s) => {
            const id = s.conversation_id || s.session_id || '';
            const active = id === activeId;
            return (
              <div
                key={id}
                onClick={() => onSelect(id)}
                className={`group flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-2 ${active ? 'bg-ui-subtle' : 'hover:bg-ui-hover'}`}
              >
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm text-ui-text">{s.title || 'Chat'}</p>
                  <p className="text-xs text-ui-text3">{relTime(s.updated_at || s.last_activity_at || s.created_at)}</p>
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); onDelete(id); }}
                  title="Delete chat"
                  className="text-ui-text3 opacity-0 transition hover:text-danger-text group-hover:opacity-100"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SessionsDrawer;
